export const EVENTS = {
  LOGIN: "login",
  ONBOARDED: "onboarded_user",

  // Onboarding steps
  ONBOARDING_STEP_1_STARTED: "onboarding_step_1_started",
  ONBOARDING_STEP_1_COMPLETED: "onboarding_step_1_completed",
  ONBOARDING_STEP_2_STARTED: "onboarding_step_2_started",
  ONBOARDING_STEP_2_COMPLETED: "onboarding_step_2_completed",

  VIEW_PRODUCT: "view_product",
  ADD_TO_CART: "add_to_cart",
  REMOVE_FROM_CART: "remove_from_cart",
  CART_STEP: "cart_step",
  ADDRESS_STEP: "address_step",
  COUPON_STEP: "coupon_step",
  PAYMENT_INITIATED: "payment_initiated",
  PAYMENT_COMPLETED: "payment_completed",
  ORDER_PLACED: "order_placed"
};
